import { PlayerWithReadinessModel } from "../../../generated/from-api/models/dtos/player-with-readiness.model";

export const getReadinessScoreForUserByType = (
  type: "category" | "gamePlan",
  identifier: string,
  userId: string,
  readinessScores: PlayerWithReadinessModel[]
): number => {
  const playerWithReadiness = readinessScores.find((s) => s.userId === userId);
  const currentReadiness = playerWithReadiness
    ? playerWithReadiness.readinessScores
    : undefined;

  if (currentReadiness) {
    if (type === "category") {
      const categoryScore = currentReadiness.find(
        (r) => r.scoreType === identifier
      );
      if (categoryScore) {
        return categoryScore.score;
      }
    } else if (type === "gamePlan") {
      const gamePlanScore = currentReadiness.find(
        (r) => r.gamePlanId && r.gamePlanId === identifier
      );
      if (gamePlanScore) {
        return gamePlanScore.score;
      }
    }
  }

  return 0;
};
